import React, { useEffect, useState, useMemo } from 'react';
import "./SlotForm.scss"
import Dropdown from '../../UI/Dropdown/Dropdown';
import Input from '../../UI/Input/Input';
import { useSelector, useDispatch } from 'react-redux';
import { useFetching } from '../../../hooks/useFetching';
import { useNavigate } from 'react-router-dom';
import PostService from '../../../API/PostService';
import { createTimeSlotsForSpecialist, createTimeSlotsWithHoursSum } from '../../../helpers/table';
import { secondsToTime, getWorkTime, convertDateFormat, timeToSeconds, parseDateToTimestamp } from '../../../helpers/datetime';
import { setSlotsAction } from '../../../store/scheduleReducer';

const SlotForm = ({ id = null, closeModal = null, slot = null, position = null, salon = null, date = null, listId = null }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [timeSlots, setTimeSlots] = useState([])
    const [slotsEnd, setSlotsEnd] = useState([])

    const [timeStart, setTimeStart] = useState(null)
    const [timeEnd, setTimeEnd] = useState(null)

    const [config, setConfig] = useState({});
    const [enableFinish, setEnableFinish] = useState(false);
    const [currentSpecialist, setCurrentSpecialist] = useState(null);
    const [currentSalon, setCurrentSalon] = useState(salon);
    // const [busySpecialists, setBusySpecialists] = useState([]);
    // const [absentees, setAbsentees] = useState([]);

    const [canEdit, setCanEdit] = useState(false);
    const [edited, setEdited] = useState(false);

    const specialists = useSelector(state => state.schedule.specialists);
    const salons = useSelector(state => state.schedule.salons);
    const slots = useSelector(state => state.schedule.slots);
    const currentSchedule = useSelector(state => state.schedule.currentSchedule);

    // получаем список занятых в этот день сотрудников
    const busySpecialists = useMemo(() => {
        // принимает дату в формате timestamp функция parseDateToTimestamp() парсит дату формата dd.mm.yyyy в формат timestamp
        const dateTimestamp = slot?.date_timestamp ? slot.date_timestamp : parseDateToTimestamp(date);

        const matchingSlots = slots.filter((s) => s.date_timestamp === dateTimestamp);
        const workerIds = matchingSlots.map((s) => s.worker_id);
        return workerIds;
    }, [slots]);

    // получаем список отсутвтующих в этот день сотрудников
    const absentees = useMemo(() => {
        // принимает дату в формате timestamp функция parseDateToTimestamp() парсит дату формата dd.mm.yyyy в формат timestamp
        const dateTimestamp = slot?.date_timestamp ? slot.date_timestamp : parseDateToTimestamp(date);

        const workerIds = specialists.reduce((acc, s) => {
            const isAbsent = s.leaves.some(l => 
                l.date_start_timestamp <= dateTimestamp && 
                l.date_end_timestamp >= dateTimestamp
            );
            if (isAbsent) {
                acc.push(s.id);
            }
            return acc;
        }, []);

        return workerIds;
    }, [slots]);

    useEffect(() => {
        setTimeout(() => {
            setCanEdit(true)
        }, 500);

        setConfig({
            ...config,
            id: slot?.id ? slot.id : null,
            worker_id: slot?.worker_id ? slot.worker_id : null,
            time_end: slot?.time_end ? slot.time_end : 79200,
            time_start: slot?.time_start ? slot.time_start : 36000,
            site_id: salon?.id ? salon?.id : slot.site_id,
            list_id: listId ? listId : slot.list_id,
            position_id: position?.id ? position.id : slot.position,
            date: date ? date : null
        })
    }, [])

    useEffect(() => {
        const hoursStart = slot?.time_start ? slot.time_start : currentSalon?.settings.time_start
        const hoursEnd = slot?.time_end ? slot.time_end : currentSalon?.settings.time_end
        
        if (hoursStart && hoursStart) {
            setSlotsEnd(createTimeSlotsWithHoursSum(hoursStart, hoursEnd))
            setTimeSlots(createTimeSlotsForSpecialist(hoursStart, hoursEnd))
        } else {
            setSlotsEnd(createTimeSlotsWithHoursSum())
            setTimeSlots(createTimeSlotsForSpecialist(hoursStart, hoursEnd))
        }

        if (slot?.time_start && slot?.time_end) {
            setTimeStart(secondsToTime(slot?.time_start))
            setTimeEnd(getWorkTime(slot?.time_start, slot?.time_end))
        } else if (hoursEnd && hoursStart) {
            setTimeEnd(getWorkTime(hoursStart, hoursEnd))
        } else {
            setTimeEnd(slotsEnd[slotsEnd.length - 1])
        }
    }, [currentSalon])

    useEffect(() => {
        if (specialists && slot) {
            const worker = specialists.find(specialist => specialist.id == slot.worker_id)
            setCurrentSpecialist(worker)
        }

        if (salons && slot) {
            const currentSalon = salons.find(salon => salon.id == slot.site_id)
            setCurrentSalon(currentSalon)
        }
    }, [slot])

    const recieveSpecialist = (value) => {
        let newConfig = { ...config, worker_id: value }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const saveChanges = () => {
        fetchUpdateSlot(null, config);
    }

    // проверяем форму на валидность
    const checkEnableFinish = (config, oldConfig) => {
        if ((JSON.stringify(config) !== JSON.stringify(oldConfig)) && canEdit) {
            setEdited(true)
        }

        let enable = true;
        if (!config.position_id) enable = false;
        if (!config.site_id) enable = false;
        if (!config.worker_id) enable = false;
        if (!config.time_end) enable = false;
        if (!config.time_start) enable = false;

        setEnableFinish(enable)
    }

    const selectedHoursStart = (value) => {
        setTimeStart(value);
        const seconds = timeToSeconds(value);
        let newConfig = { ...config, time_start: seconds };
        checkEnableFinish(newConfig, config);
        setConfig(newConfig);
    };

    const selectedHoursEnd = (value) => {
        const seconds = timeToSeconds(value.time);
        let newConfig = { ...config, time_end: seconds };
        checkEnableFinish(newConfig, config);
        setConfig(newConfig);
    };

    const [fetchSlots] = useFetching(async (currentSchedule) => {
        const response = await PostService.getListItems(currentSchedule);

        if (response.data.success && response.data.result !== false) {
            dispatch(setSlotsAction(response.data.result[currentSchedule]));
        }
    })

    const [fetchUpdateSlot] = useFetching(async (id = null, data = null) => {
        let response;

        if (!data) {
            response = await PostService.deleteSlot(id)
        } else {
            response = await PostService.editSlotItem(data)
        }

        if (response.data.success && response.data.result !== false) {
            fetchSlots(currentSchedule)
            navigate('/schedule/');
        }
    })

    const deleteSlot = () => {
        fetchUpdateSlot(id);
    }

    return (
        <div className="slot-form">
            {
                !confirmDelete &&
                <>
                    <div className="slot-form__headline">
                        <h3>{currentSalon ? currentSalon.description : salon?.description}, {slot?.date_format ? convertDateFormat(slot.date_format) : convertDateFormat(date)}</h3>
                    </div>
                    <div className="slot-form__specialist">
                        <Dropdown
                            busyList={busySpecialists}
                            absentees={absentees}
                            optionsList={specialists}
                            selectedHandler={recieveSpecialist}
                            label='Сотрудник'
                            type='specialist'
                            optionSelected={currentSpecialist} />
                        <span className="slot-form__specialist-warning">Чтобы выбрать занятого сотрудника, сначала освободите его</span>
                    </div>
                    <div className="slot-form__time-block">
                        <div className="slot-form__time-selector">
                            <Dropdown
                                optionsList={timeSlots}
                                optionSelected={timeStart ? timeStart : timeSlots[0]}
                                type='startHours'
                                label=''
                                selectedHandler={selectedHoursStart} />
                        </div>
                        <div className="slot-form-hours__line"></div>
                        <div className="slot-form__time-selector">
                            <Dropdown
                                optionsList={slotsEnd}
                                optionSelected={timeEnd ? timeEnd : slotsEnd[slotsEnd.length - 1]}
                                type='endHours'
                                label=''
                                selectedHandler={selectedHoursEnd} />
                        </div>
                    </div>
                    <div className="slot-form__submit">
                        <>
                            <button className='g-button' disabled={!edited || !enableFinish} onClick={saveChanges}>Сохранить</button>
                            <button className='g-button-secondary' onClick={closeModal}>Отменить</button>
                            {id &&
                                <button className='g-button-link' onClick={() => setConfirmDelete(true)}>Удалить</button>
                            }
                        </>
                    </div>
                </>
            }
            {confirmDelete &&
                <>
                    <div className="record-form__headline">
                        <h3>Подтверждение</h3>
                    </div>
                    <div className="record-form__description">
                        Вы действительно хотите удалить запись?
                    </div>
                    <div className="record-form__btns">
                        <button className='g-button' onClick={deleteSlot}>Удалить</button>
                        <button className='g-button-secondary' onClick={() => setConfirmDelete(false)}>Отменить</button>
                    </div>
                </>
            }
        </div>
    );
};

export default SlotForm;
